export function initialize(appInstance: any) {
  const intl = appInstance.lookup('service:intl');

  // Check for locale cookie (only in browser, not Fastboot)
  if (typeof document !== 'undefined') {
    const cookies = document.cookie.split(';');
    let locale = 'en'; // default

    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'locale') {
        locale = value || 'en';
        break;
      }
    }

    // Set locale (use 'es' for Spanish, ember-intl expects 'es')
    if (locale === 'es' || locale === 'es-AR') {
      intl.setLocale(['es']);
    } else {
      intl.setLocale(['en']);
    }
  } else {
    // Default to English in Fastboot
    intl.setLocale(['en']);
  }
}

export default {
  name: 'ember-intl',
  initialize
};

